module.exports = __webpack_public_path__ + "img/loyalty-program-setup.5d3f40d6.jpg";